import axios from "../http_v2";
export default {
  type: {
    tree(params) {
      return axios.get("content-service/doc_category/tree", params);
    },
    add(params) {
      return axios.post("content-service/doc_category", params);
    },
    update(params) {
      return axios.put("content-service/doc_category", params);
    },
    delete(params) {
      return axios.delete("content-service/doc_category/" + params.id, {});
    }
  },
  add(params) {
    return axios.post("content-service/doc_article", params);
  },
  update(params) {
    return axios.put("content-service/doc_article", params);
  },
  list(params) {
    return axios.get("content-service/doc_article/page", params);
  },
  info(params) {
    return axios.get("content-service/doc_article/" + params.id, params);
  },
  del(params) {
    return axios.delete("content-service/doc_article/" + params.id, {});
  },
  topic(params) {
    return axios.get("content-service/doc_article/page/for/topic", params);
  },
};
